export const getErrorMessage = (
  error: any,
  fallbackMessage?: string,
  nestedErrorKeys?: string[],
  preferFirstNestedError: boolean = false
): string | undefined => {
  if (!error) return undefined;

  if (error.message) return error.message;

  if (error._errors && Array.isArray(error._errors) && error._errors.length > 0) {
    return error._errors[0];
  }

  if (typeof error === 'object' && nestedErrorKeys && nestedErrorKeys.length > 0) {
    if (preferFirstNestedError) {
      for (const key of nestedErrorKeys) {
        if (error[key]?.message) {
          return error[key].message;
        }
      }
    }

    const hasNestedError = nestedErrorKeys.some((key) => !!error[key]?.message);
    if (hasNestedError && fallbackMessage) {
      return fallbackMessage;
    }
  }

  return undefined;
};
